@if (items?.length) {
<nav
	aria-label="breadcrumb"
	class="dynamic-breadcrumb"
	[style.backgroundColor]="bgColor"
>
	<ol class="breadcrumb mb-0">
		@for (item of items; track item?.label; let isLast = $last) {
		<li
			class="breadcrumb-item"
			[class.active]="isLast"
			[attr.aria-current]="isLast ? 'page' : null"
			[style.fontSize]="fontSize"
		>
			@if (!isLast && item?.routerLink) {
			<a [routerLink]="item.routerLink" [style.color]="fontColor">{{ item.label }}</a>
			}
			@if (isLast || !item?.routerLink) {
			<span [style.color]="isLast ? lastLinkColor : fontColor">{{ item.label }}</span>
			}
		</li>
		}
	</ol>
</nav>
}